// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"e93b3a92","2931":"0de77106","5112":"c2f356f2","5202":"daf2524e","5268":"90f9942b","7695":"c2f356f2"}[chunkId] + ".chunk.css";
};